module.exports = __webpack_public_path__ + "static/profile-brittany-canaski-c629d625a3d822c9f6cc05656faed1d0.png";